import { useMutation } from '@apollo/client';
import PATCH_PREREQUISITE_MUTATION from '../mutations/PATCH_PREREQUISITE_MUTATION';

export default function usePatchPrerequisiteMutation() {
    return useMutation( PATCH_PREREQUISITE_MUTATION );
}
